module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "google_si.0c9940fa.svg";